import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import { jsx } from 'react/jsx-runtime';
import { ZapCard } from '../ZapCard/ZapCard.es.js';
import '../../display/Icon/Icon.es.js';
import '../../navigation/Link/Link.es.js';
import 'react';
import 'react-imgix';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';

const root = "_root_12vxn_1";
const container = "_container_12vxn_15";
const styles = {
	root: root,
	container: container
};

const ZapCardSection = ({ items, layout = "card" }) => {
  var _a;
  if (items.length > 3 && layout !== "auto") {
    console.error("Max 3 items are allowed in ZapCardSection component");
  }
  const maxItems = layout === "auto" ? items.length : 3;
  return jsx("div", { className: styles.root, "data-zds": true, children: jsx("div", { className: styles.container, "data-layout": layout, "data-zds": true, children: (_a = items === null || items === void 0 ? void 0 : items.slice(0, maxItems)) === null || _a === void 0 ? void 0 : _a.map((_a2) => {
    var { color = Colors.PrimeWhite, href } = _a2, rest = __rest(_a2, ["color", "href"]);
    return jsx(ZapCard, Object.assign({}, rest, { color, href, layout }));
  }) }) });
};

export { ZapCardSection };
//# sourceMappingURL=ZapCardSection.es.js.map
